export const LOCAL_STORAGE_KEY_IS_THEME_DARK = 'isThemeDark'
export const LOCAL_STORAGE_KEY_UI_LOCALE = 'uiLocale'
